import { tables_AutoCalculateOddRow, tables_ToggleHiddenRows, tables_ToggleHiddenRowsStateTable } from "./tables";

document.addEventListener('DOMContentLoaded', () => {
  tables_AutoCalculateOddRow();

  //Tables upcoming/all tabs handler
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (!target.classList.contains('hol-schedule-sort__btn')) return;
    if (target.classList.contains('btn-primary')) return;

    const isOnlyUpcoming = target.classList.contains('hol-schedule-sort__btn--upcoming');
    const tableEl = target.closest('.hol-schedule-common-section').querySelector('table') as HTMLTableElement;
    const stateTableEL = target.closest('.hol-schedule-common-section').querySelector('table.state-holiday-table') as HTMLTableElement;


    // switch button classes
    target.replaceClass('btn-outline-primary', 'btn-primary');
    ((target.nextElementSibling || target.previousElementSibling) as HTMLElement).replaceClass('btn-primary', 'btn-outline-primary');

    // toggle hidden rows
    tables_ToggleHiddenRows(tableEl, isOnlyUpcoming);
    tables_AutoCalculateOddRow(tableEl);
    tables_ToggleHiddenRowsStateTable(stateTableEL, isOnlyUpcoming);
  });

  //Tables dropdown tabs handler
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (!target.classList.contains('dropdown-option')) return;
    let isOnlyUpcoming = false;

    const stateTableEL = document.querySelector('table.state-holiday-table') as HTMLTableElement;
    if (stateTableEL && stateTableEL.classList.contains("upcoming-table")) {
      isOnlyUpcoming = true;
    }

    tables_ToggleHiddenRowsStateTable(stateTableEL, isOnlyUpcoming);
  });

  //Show Schedule button click handler
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (!target.classList.contains('btn-state-table-schedule')) return;

    let isOnlyUpcoming = false;

    const stateTableEL = document.querySelector('table.state-holiday-table') as HTMLTableElement;
    if (stateTableEL && stateTableEL.classList.contains("upcoming-table")) {
      isOnlyUpcoming = true;
    }

    tables_ToggleHiddenRowsStateTable(stateTableEL, isOnlyUpcoming);
  });
});
